import React, { Component } from "react";
import { MdAssignmentInd } from "react-icons/md";
import { MdSecurity } from "react-icons/md";
import swal from "sweetalert";
import Swal from "sweetalert2";
import "./auth_style.css";

class AuthLogin extends Component {
  state = {
    user: "",
    password: "",
    userVerified: [],
    userLogged: []
  };

  setUser = user => this.setState({ user: user });
  setPassword = password => this.setState({ password: password });

  authentication = e => {
    e.preventDefault();
    let user = {
      username: this.state.user,
      password: this.state.password
    };
    this.verifyUserInApiData(user);
  };

  verifyUserInApiData = user => {
    Swal.fire({
      title: "Aguarde...",
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
    let setHead = new Headers();
    setHead.append("Content-Type", "application/json");
    fetch(`https://appv1.all.com.br/logarFuncionario`, {
      method: "post",
      headers: setHead,
      body: JSON.stringify({
        login: user.username,
        password: user.password
      })
    }).then(async response => {
      if (response.status === 200) {
        Swal.close();
        let data = response.json();
        await data.then(async data => {
          const verifyEmployeeInApiData = () => {
            return new Promise(async (resolve, reject) => {
              if (data) resolve(await this.setState({ userVerified: data }));
              else reject(this.setState({ userVerified: [] }));
            });
          };
          await verifyEmployeeInApiData();
        });
        if (
          this.state.userVerified.length > 0 &&
          this.state.userVerified[0].status !== "falha"
        ) {
          localStorage.setItem(
            "token",
            JSON.stringify({ token: this.state.userVerified[0].token })
          );
          window.location.href = "/painel";
        } else {
          Swal.close();
          swal({
            title: "Login Incorreto",
            text: "Usuário ou senha inválidos!",
            icon: "warning"
          });
        }
      } else {
        Swal.close();
        swal({
          title: "Login Incorreto",
          text: "Erro na requisição!",
          icon: "error"
        });
      }
    });
  };

  render() {
    document.body.style.backgroundColor = "#357ae8";
    return (
      <React.Fragment>
        <div
          className="container login justify-content-center"
          style={{
            display: "block",
            margin: "auto",
            marginTop: "110px"
          }}
        >
          <div className="logo-content">
            <center>
              <p style={{ padding: "25px" }}>
                <img
                  src="https://viabilidades.all.com.br/imagens/allnet-logo.png"
                  alt="logo"
                />
              </p>
              <p style={{ color: "white" }}>Seja bem-vindo!</p>
              <p style={{ color: "white" }}>
                Informe seus dados para o acesso.
              </p>
            </center>
          </div>
          <div className="middle-content">
            <div className="row">
              <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
                <div className="card-login card-signin my-5">
                  <div className="card-body">
                    <form
                      className="form-signin"
                      onSubmit={e => this.authentication(e)}
                    >
                      <div className="form-label-group">
                        <input
                          ref="user"
                          type="text"
                          id="inputUser"
                          className="form-control"
                          placeholder="Usuário"
                          required
                          autoFocus
                          onChange={e => this.setUser(e.target.value)}
                        />
                        <label htmlFor="inputUser">
                          <MdAssignmentInd /> Usuário
                        </label>
                      </div>
                      <div className="form-label-group">
                        <input
                          ref="password"
                          type="password"
                          id="inputPassword"
                          className="form-control"
                          placeholder="Senha"
                          autoComplete="true"
                          current-password="true"
                          required
                          onChange={e => this.setPassword(e.target.value)}
                        />
                        <label htmlFor="inputPassword">
                          <MdSecurity /> Senha
                        </label>
                      </div>
                      <button
                        className="btn btn-lg btn-primary btn-block text-uppercase"
                        type="submit"
                      >
                        <div style={{ display: "block", marginTop: "-4px" }}>
                          <span>Acessar</span>
                        </div>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <center>
            <p>
              <img
                alt="footer"
                src="https://viabilidades.all.com.br/imagens/20.png"
              />
            </p>
            <span
              style={{
                textTransform: "none !important",
                fontSize: "14px",
                color: "#BA9765",
                paddingTop: "25px"
              }}
            >
              © 2019 | ALL NET Redes Corporativas.
            </span>
          </center>
        </div>
      </React.Fragment>
    );
  }
}

export default AuthLogin;
